/**
 * User types from `/auth/user-me`.
 * The API returns the enum name; the numeric code is the backend value.
 *
 * Customer  => 0
 * Admin     => 1
 * Agent     => 5
 * Courier   => 6
 * ShopStaff => 7
 * Partner   => 8
 */
export const AUTH_USER_TYPE = {
  CUSTOMER: 'Customer',
  ADMIN: 'Admin',
  AGENT: 'Agent',
  COURIER: 'Courier',
  SHOP_STAFF: 'ShopStaff',
  PARTNER: 'Partner',
} as const;

export type AuthUserType = (typeof AUTH_USER_TYPE)[keyof typeof AUTH_USER_TYPE];

export const AUTH_USER_TYPE_CODE: Record<AuthUserType, number> = {
  Customer: 0,
  Admin: 1,
  Agent: 5,
  Courier: 6,
  ShopStaff: 7,
  Partner: 8,
};

export const isPartnerUser = (userType: string | number | null | undefined): boolean =>
  userType === AUTH_USER_TYPE.PARTNER || userType === AUTH_USER_TYPE_CODE.Partner;
